var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPopularZoneIconProduct = function SvgPopularZoneIconProduct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_14733_6426)",
    d: "M30.59 20.364c-.34 0-.684-.089-.998-.276-.958-.572-1.285-1.838-.735-2.83a8.95 8.95 0 0 0 .846-6.633c-.585-2.255-1.985-4.139-3.94-5.306a8.16 8.16 0 0 0-6.415-.874c-2.181.605-4.004 2.051-5.136 4.073-.553.989-1.777 1.328-2.735.759-.957-.572-1.285-1.837-.734-2.83 1.663-2.978 4.35-5.111 7.565-6.002S24.882.01 27.763 1.73c2.884 1.72 4.945 4.5 5.807 7.823s.42 6.794-1.247 9.772a1.99 1.99 0 0 1-1.736 1.036z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_14733_6426)",
    d: "M32.387 25.334 4.843 8.896C2.69 7.61 0 9.218 0 11.785v6.482c0 .214.111.41.29.52l26.083 15.567c.178.108.4.108.579 0l5.432-3.241c2.153-1.286 2.153-4.497 0-5.779z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_14733_6426)",
    d: "m15.624 41.118 9.073-5.413a.304.304 0 0 0 0-.52L.436 20.71c-.194-.115-.436.03-.436.26v10.827c0 .214.111.411.29.52l14.752 8.802c.178.109.4.109.579 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_14733_6426)",
    d: "M0 34.492v10.166c0 2.568 2.69 4.175 4.843 2.89l8.52-5.085a.304.304 0 0 0 0-.52L.436 34.232c-.194-.115-.436.03-.436.26"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14733_6426",
    x1: 17,
    x2: 17,
    y1: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14733_6426",
    x1: 17,
    x2: 17,
    y1: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14733_6426",
    x1: 17,
    x2: 17,
    y1: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14733_6426",
    x1: 17,
    x2: 17,
    y1: 0,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ACA2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8FF"
  })))));
};
export default SvgPopularZoneIconProduct;